; (function () {
	"use strict";
	function TestimonialsSlider() {
		var fn = {
			init: function () {
				fn.initSliders();
			},

			initSliders: function() {
				jQuery('.testimonials-slider .splide').each(function(index, element) {
					fn.initSlider(element);
				})
			},

			initSlider: function (element) {
				let splide = new Splide(element, {
					type: 'fade',
					rewind: true,
					autoplay: true,
					interval: 10000,
					speed: 600,
					pauseOnHover: true,
					perPage: 1,
					perMove: 1,
					gap: 0,
					fixedWidth: false,
					width: '100%',
					pagination: false,
					arrows: false,

				}).mount();

				let prevButton = element.querySelector('.testimonials-slider__nav-button--prev');
				let nextButton = element.querySelector('.testimonials-slider__nav-button--next');

				// Add event listeners
				prevButton.addEventListener('click', function () {
					splide.go('<'); // Move to the previous slide
				});
				nextButton.addEventListener('click', function () {
					splide.go('>'); // Move to the next slide
				});
			},
		}
		jQuery(document).ready(fn.init);
	}
	new TestimonialsSlider();
})();